import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const CookiePolicy = () => {
  return (
    <div className="legal-page">
      {/* Hero Section */}
      <section className="legal-hero parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Cookie Policy" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="hero-content"
            >
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span>/</span>
                <span>Cookie Policy</span>
              </div>
              <h1>Cookie Policy</h1>
              <p>Learn about how we use cookies to enhance your browsing experience.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="legal-document"
            >
              <div className="document-header">
                <h2>Cookie Policy for Efficient Group</h2>
                <p className="last-updated">Last updated: December 2024</p>
              </div>

              <div className="document-content">
                <section className="legal-section">
                  <h3>1. What Are Cookies</h3>
                  <p>Cookies are small text files that are placed on your computer or mobile device when you visit our website. They are widely used to make websites work more efficiently and provide information to website owners.</p>
                </section>

                <section className="legal-section">
                  <h3>2. How We Use Cookies</h3>
                  <p>We use cookies for several purposes:</p>
                  <ul>
                    <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
                    <li><strong>Performance Cookies:</strong> Help us understand how visitors interact with our website</li>
                    <li><strong>Functionality Cookies:</strong> Remember your preferences and settings</li>
                    <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>3. Types of Cookies We Use</h3>
                  
                  <h4>Essential Cookies</h4>
                  <p>These cookies are necessary for the website to function and cannot be switched off. They include:</p>
                  <ul>
                    <li>Session management cookies</li>
                    <li>Security cookies</li>
                    <li>Load balancing cookies</li>
                  </ul>

                  <h4>Analytics Cookies</h4>
                  <p>We use analytics cookies to understand how visitors use our website:</p>
                  <ul>
                    <li>Google Analytics (if implemented)</li>
                    <li>Page view tracking</li>
                    <li>User behavior analysis</li>
                  </ul>

                  <h4>Functional Cookies</h4>
                  <p>These cookies enhance functionality and personalization:</p>
                  <ul>
                    <li>Language preferences</li>
                    <li>Form data retention</li>
                    <li>User interface preferences</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>4. Third-Party Cookies</h3>
                  <p>Some cookies are placed by third-party services that appear on our pages:</p>
                  <ul>
                    <li><strong>Google Fonts:</strong> For web font delivery</li>
                    <li><strong>Font Awesome:</strong> For icon display</li>
                    <li><strong>Unsplash:</strong> For image delivery</li>
                    <li><strong>Social Media:</strong> If social sharing is enabled</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>5. Managing Cookies</h3>
                  <p>You can control and manage cookies in several ways:</p>
                  
                  <h4>Browser Settings</h4>
                  <p>Most browsers allow you to:</p>
                  <ul>
                    <li>View cookies stored on your device</li>
                    <li>Delete existing cookies</li>
                    <li>Block cookies from specific sites</li>
                    <li>Block all cookies</li>
                  </ul>

                  <h4>Browser-Specific Instructions</h4>
                  <ul>
                    <li><strong>Chrome:</strong> Settings > Privacy and Security > Cookies</li>
                    <li><strong>Firefox:</strong> Options > Privacy & Security > Cookies</li>
                    <li><strong>Safari:</strong> Preferences > Privacy > Cookies</li>
                    <li><strong>Edge:</strong> Settings > Cookies and Site Permissions</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>6. Impact of Disabling Cookies</h3>
                  <p>Disabling cookies may affect your experience on our website:</p>
                  <ul>
                    <li>Some features may not work properly</li>
                    <li>Forms may not remember your information</li>
                    <li>Preferences may not be saved</li>
                    <li>Analytics data will not be collected</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>7. Cookie Retention</h3>
                  <p>Different cookies have different lifespans:</p>
                  <ul>
                    <li><strong>Session Cookies:</strong> Deleted when you close your browser</li>
                    <li><strong>Persistent Cookies:</strong> Remain until expiry date or manual deletion</li>
                    <li><strong>Analytics Cookies:</strong> Typically expire after 2 years</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>8. Updates to This Policy</h3>
                  <p>We may update this Cookie Policy from time to time to reflect changes in our practices or for legal reasons. Please check this page periodically for updates.</p>
                </section>

                <section className="legal-section">
                  <h3>9. Contact Us</h3>
                  <p>If you have questions about our use of cookies, please contact us:</p>
                  <div className="contact-info">
                    <p><strong>Email:</strong> privacy@efficientgroupdubai.com</p>
                    <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                    <p><strong>Address:</strong> 123 Business District, Dubai, UAE</p>
                  </div>
                </section>

                <section className="legal-section">
                  <h3>10. Consent</h3>
                  <p>By continuing to use our website, you consent to our use of cookies as described in this policy. You can withdraw your consent at any time by adjusting your browser settings.</p>
                </section>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;